/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import AxiosHelper from './AxiosHelper';
import { EndPointsNames, ApiCredentialsType, InitApiType } from '_core/types';
import HandlePromise from './HandlePromisse';
import { Bundle } from '_core/util';
import { getPropApi } from '_core/config/api/Endpoints';

export const get = (
  apiDomain: EndPointsNames,
  path: string,
  credentialsType: ApiCredentialsType,
  init: InitApiType,
): Promise<any> => {
  const config = Bundle.getValue('config');
  const { apiType, endpoint } = getPropApi(
    config.service.environment,
    apiDomain,
  );
  const isMock = config.service.environment === 'MOCK';
  return HandlePromise(
    AxiosHelper.get(apiDomain, path, credentialsType, init),
    apiType,
    isMock,
    endpoint,
  );
};
export const post = (
  apiDomain: EndPointsNames,
  path: string,
  credentialsType: ApiCredentialsType,
  init: InitApiType,
): Promise<any> => {
  const config = Bundle.getValue('config');
  const { apiType, endpoint } = getPropApi(
    config.service.environment,
    apiDomain,
  );
  const isMock = config.service.environment === 'MOCK';
  return HandlePromise(
    AxiosHelper.post(apiDomain, path, credentialsType, init),
    apiType,
    isMock,
    endpoint,
  );
};
export const put = (
  apiDomain: EndPointsNames,
  path: string,
  credentialsType: ApiCredentialsType,
  init: InitApiType,
): Promise<any> => {
  const config = Bundle.getValue('config');
  const { apiType, endpoint } = getPropApi(
    config.service.environment,
    apiDomain,
  );
  const isMock = config.service.environment === 'MOCK';
  return HandlePromise(
    AxiosHelper.put(apiDomain, path, credentialsType, init),
    apiType,
    isMock,
    endpoint,
  );
};
export const deleteop = (
  apiDomain: EndPointsNames,
  path: string,
  credentialsType: ApiCredentialsType,
  init: InitApiType,
): Promise<any> => {
  const config = Bundle.getValue('config');
  const { apiType, endpoint } = getPropApi(
    config.service.environment,
    apiDomain,
  );
  const isMock = config.service.environment === 'MOCK';
  return HandlePromise(
    AxiosHelper.delete(apiDomain, path, credentialsType, init),
    apiType,
    isMock,
    endpoint,
  );
};
